export enum SecurityAccessLevelEnum {
  NoAccess = 0,
  ReadOnlyAccess = 1,
  FullAccess = 2,
}
